import { CheckboxField } from '../fields/checkboxField';
import { FormList } from '../fields/formList';
import { RadioButtonsField } from '../fields/radioButtonsField';
import { TextField } from '../fields/textField';
import { FormElement, FormElementConfig } from '../formElement';
import { FormStep } from '../formStep';
import { ConnectionTypeSelectorType } from '../shared/connectionTypeSelectorType';
import { GridControlImplementationPreferenceType } from '../shared/gridControlImplementationPreferenceType';
import { LoadManagementType } from '../shared/loadManagementType';
import { WithOptional } from '../utility';

type ConfigProps = WithOptional<
    ControllableConsumptionDevicesFormStep,
    keyof FormStep
>;

export class ControllableConsumptionDevicesFormStep extends FormStep {
    public readonly controllableConsumptionDevicesInfo: FormElement;
    public readonly gridControlConditionsAccepted: CheckboxField;
    public readonly gridControlImplementationPreference: RadioButtonsField<
        GridControlImplementationPreferenceType
    >;
    public readonly connectionTypeSelector: RadioButtonsField<
        ConnectionTypeSelectorType
    >;
    public readonly maxConnectionLoad: TextField;
    public readonly identificationNumbersOfRegisteredConsumptionDevices: FormList<
        TextField,
        FormElementConfig
    >;
    public readonly controllableConsumptionFacilitiesRequirementInfo: FormElement;

    constructor(config: ConfigProps) {
        super(config);
        this.controllableConsumptionDevicesInfo =
            config.controllableConsumptionDevicesInfo;
        this.gridControlConditionsAccepted =
            config.gridControlConditionsAccepted;
        this.gridControlImplementationPreference =
            config.gridControlImplementationPreference;
        this.connectionTypeSelector = config.connectionTypeSelector;
        this.maxConnectionLoad = config.maxConnectionLoad;
        this.identificationNumbersOfRegisteredConsumptionDevices =
            config.identificationNumbersOfRegisteredConsumptionDevices;
        this.controllableConsumptionFacilitiesRequirementInfo =
            config.controllableConsumptionFacilitiesRequirementInfo;
    }
}
